import { defineStore } from "pinia";
import { ref } from "vue";

export const useNotificationStore = defineStore("notification", () => {
  const message = ref("");   // Mensagem da notificação
  const type = ref("");      // Tipo: success ou error
  const visible = ref(false); // Controle de visibilidade
  let timeout = null; // Referência para limpar o temporizador

  // Exibir uma notificação
  const showNotification = (msg, msgType = "success") => {
    message.value = msg;
    type.value = msgType;
    visible.value = true;

    // Limpar timeout anterior, se existir
    if (timeout) {
        clearTimeout(timeout);
      }

    // Ocultar após 3 segundos
    setTimeout(() => {
      visible.value = false;
    }, 5000);
  };

  return { message, type, visible, showNotification };
});
